import { render, staticRenderFns } from "./infoModal.vue?vue&type=template&id=f49f3432&scoped=true&"
import script from "./infoModal.vue?vue&type=script&lang=js&"
export * from "./infoModal.vue?vue&type=script&lang=js&"
import style0 from "./infoModal.vue?vue&type=style&index=0&id=f49f3432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49f3432",
  null
  
)

export default component.exports